import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function NoFees({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M16.8754 13.968C17.734 13.968 18.358 13.536 18.358 12.7626C18.358 11.9413 17.718 11.7546 16.934 11.584C16.3687 11.4613 16.102 11.3706 16.102 11.0613C16.102 10.7893 16.374 10.6133 16.79 10.6133C17.1847 10.6133 17.4834 10.8053 17.526 11.1893H18.2674C18.2087 10.4213 17.654 9.99998 16.7954 9.99998C15.9474 9.99998 15.334 10.3893 15.334 11.1413C15.334 11.936 15.958 12.1173 16.6407 12.272L16.6787 12.2807C17.2378 12.4087 17.5847 12.4882 17.5847 12.8533C17.5847 13.2053 17.238 13.344 16.8434 13.344C16.2994 13.344 16.038 13.1626 15.9847 12.704H15.2274C15.254 13.5093 15.8407 13.968 16.8754 13.968Z"
        fill={iconColor}
      />
      <Path
        d="M5.33325 13.8826H6.10659V12.304H7.76525V11.6426H6.10659V10.7253H8.06392V10.0693H5.33325V13.8826Z"
        fill={iconColor}
      />
      <Path
        d="M8.60659 13.8826H11.4279V13.2373H9.37992V12.208H11.1613V11.5733H9.37992V10.72H11.4119V10.0693H8.60659V13.8826Z"
        fill={iconColor}
      />
      <Path
        d="M14.8367 13.8826H12.0153V10.0693H14.8207V10.72H12.7887V11.5733H14.57V12.208H12.7887V13.2373H14.8367V13.8826Z"
        fill={iconColor}
      />
      <Path
        d="M1.33325 12C1.33325 6.10894 6.10888 1.33331 11.9999 1.33331C17.891 1.33331 22.6666 6.10894 22.6666 12C22.6666 17.891 17.891 22.6666 11.9999 22.6666C6.10888 22.6666 1.33325 17.891 1.33325 12ZM11.9999 2.66665C6.84526 2.66665 2.66659 6.84532 2.66659 12C2.66659 14.3374 3.5258 16.4741 4.94561 18.1115L7.72379 15.3333H9.60941L5.88842 19.0543C7.52583 20.4741 9.66254 21.3333 11.9999 21.3333C17.1546 21.3333 21.3333 17.1546 21.3333 12C21.3333 9.6626 20.474 7.52589 19.0542 5.88848L16.2761 8.66665H14.3905L18.1114 4.94567C16.474 3.52586 14.3373 2.66665 11.9999 2.66665Z"
        fill={iconColor}
      />
    </Svg>
  );
}
